<v-app id="app" data-theme="light">


  <div class="n-pt-5 n-position-relative n-z-index-1  n-bg-primary-5">
    <div class="n-container">
      <ul class="v-breadcrumbs n-p-0 theme--light" v-if="breadcrumbList.length !== 0">

        <template v-for="(breadcrumb, idx) in breadcrumbList">
          <a :href="breadcrumb.href" class="n-color-font-primary n-text-body-default n-text-decoration-none">
            {{$t(breadcrumb.text)}}
          </a>
          <li class="v-breadcrumbs__divider"><i class="n-icon-arrow-left n-icon n-icon-size-16"></i></li>
        </template>

        <li class="n-color-font-secondary n-text-body-default">
          <div class="v-breadcrumbs__item v-breadcrumbs__item--disabled">
            {{$route.meta.pageTitle}}
          </div>
        </li>

      </ul>
    </div>
  </div>

  <header class="n-pt-6 n-pb-5 n-bg-primary-5">
    <div class="n-container">
      <h4 class="n-text-h4 n-color-font-primary n-font-bold">
        {{$route.meta.pageTitle}}
      </h4>
    </div>
  </header>

  <n-container>
    <router-view />
  </n-container>
</v-app>